import Vue from 'vue'
import Modal from '@/components/Modal/index.vue'

type IOptions = ISui.IConfirmOptions | ISui.IAlertOptions

const ModalConstructor = Vue.extend(Modal)
export class ModalExtendConstructor extends ModalConstructor {
  close() {
    this.$props.value = false
  }
}

let instance: ModalExtendConstructor
let defaultOptions: IOptions
let opts: IOptions
let isInit: Boolean = false

const getInstance = () => {
  if (instance) return instance

  instance = new ModalExtendConstructor({
    el: document.createElement('div')
  })

  return instance
}

const modal = (options: IOptions) => {
  const vm = getInstance()

  if (!defaultOptions) {
    defaultOptions = { content: '', btn: '', btnEmphasize: '', btnPrimary: '', ...vm.$props }
  }

  opts = { ...defaultOptions, ...options }

  Object.keys(opts).forEach((key) => {
    vm.$props[key] = opts[<keyof IOptions>key]
  })

  vm.$props.value = true

  if (!isInit) {
    vm.$on('input', (val: boolean) => {
      vm.$props.value = val
    })
    vm.$on('close', () => {
      if (opts.onClose) {
        opts.onClose.call(null)
      }
    })
    vm.$on('confirm', () => {
      if (opts.onConfirm) {
        opts.onConfirm.call(null)
      }
    })
    vm.$on('cancel', () => {
      if (opts.onCancel) {
        opts.onCancel.call(null)
      }
    })
    document.body.appendChild(vm.$el)
    isInit = true
  }
  return vm
}

export default modal
